const light = Object.freeze({
    primary: '#4D9825',
    secondary: '#494847',
    navBackground: '#FFFFFF',
    tileBackground: '#FFFFFF',
    appBackground: '#F5F5F5',
    inputBackground: '#FFFFFF',
    logoColor: '#0E0E0E',
    error: '#E4002C',
    info: '#00B1EB',
    success: '#A5BD00',
    warning: '#FAAA00',
})

const dark = Object.freeze({
    primary: '#DBE599',
    secondary: '#B6B5B5',
    navBackground: '#2C2C2C',
    tileBackground: '#2C2C2C',
    appBackground: '#1B1B1B',
    inputBackground: '#222222',
    logoColor: '#E2DBCF',
    error: '#F499AA',
    info: '#99E0F7',
    success: '#C9D766',
    warning: '#FDDD99',
})

const props = Object.freeze({
    headerLogoWidth: 150,
    headerLogoSrc: require('@/assets/custom/images/headers/living-header.jpg')
})

module.exports = Object.freeze({
    light,
    dark,
    props
})

